import React from 'react'
import Box from '@mui/system/Box'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'

// Local imports
import AdxToolTip from 'components/custom/AdxToolTip'
import defaultAvatar from 'assets/images/default_avatar.png'

const SingleAvatar = ({ name, imgUrl, active, variant, sxContainer }) => {
  const nameInitials = (name) => {
    const namesArray = name.trim().split(' ')
    if (namesArray.length === 1) return `${namesArray[0].charAt(0)}`
    else return `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`
  }
  return (
    <Box sx={{ ...sxContainer }}>
      {imgUrl ? (
        <CardMedia
          component="img"
          sx={{
            height: 40,
            width: 40,
            objectFit: 'cover',
            borderRadius: '50%',
            border: '3px solid',
            borderColor: active ? 'alternate.main' : 'gray-line.main',
          }}
          alt={`picture of ${name}`}
          src={imgUrl}
          loading="lazy"
        />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            height: 40,
            width: 40,
            objectFit: 'cover',
            borderRadius: '50%',
            border: '3px solid',
            bgcolor: active ? 'alternate.main' : 'gray-line.main',
            borderColor: active ? 'alternate.main' : 'gray-line.main',
          }}
        >
          <Typography variant={variant ? 'body1' : 'h4'} color="white.main">
            {nameInitials(name)}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

const AdxAvatarSide = ({ tooltipMax = 99, data, active }) => {
  const arrayLength = data?.length
  // const slicedData = data.slice(0, 1);
  // const remainderData = data.slice(1, arrayLength);
  const [slicedData, ...remainderData] = data || []

  if (arrayLength > 1) {
    return (
      <Box
        sx={{
          width: 100,
          height: 60,
          position: 'relative',
        }}
      >
        <AdxToolTip title={slicedData.name}>
          <Box sx={{ position: 'absolute' }}>
            <SingleAvatar
              name={slicedData.name}
              imgUrl={slicedData.profile_image_url || defaultAvatar}
            />
          </Box>
        </AdxToolTip>

        <Box sx={{ position: 'absolute', left: 23, top: 20 }}>
          <>
            {remainderData.length > 1 ? (
              <AdxToolTip
                title={
                  <Box>
                    {remainderData
                      .filter((filterItem, index) => index < tooltipMax)
                      .map((item, i) => {
                        return <Typography key={i}>{item.name}</Typography>
                      })}
                    {remainderData.length > tooltipMax ? (
                      <Typography>
                        and {remainderData.length - tooltipMax}{' '}
                        {remainderData.length - tooltipMax > 1 ? 'others' : 'other'}
                      </Typography>
                    ) : null}
                  </Box>
                }
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: 'alternate.main',
                    zIndex: 2,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography variant="subtitle1" color="default-background.main">
                    {arrayLength - 1}
                  </Typography>
                </Box>
              </AdxToolTip>
            ) : (
              <AdxToolTip title={remainderData[0].name}>
                <Box>
                  <SingleAvatar
                    name={remainderData[0].name}
                    imgUrl={remainderData[0].profile_image_url || defaultAvatar}
                  />
                </Box>
              </AdxToolTip>
            )}
          </>
        </Box>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: 100,
        height: 60,
        pl: 1,
        pt: 1,
      }}
    >
      <AdxToolTip title={slicedData?.name}>
        <Box>
          <SingleAvatar
            name={slicedData?.name}
            imgUrl={slicedData?.profile_image_url || defaultAvatar}
          />
        </Box>
      </AdxToolTip>
    </Box>
  )
}

export default AdxAvatarSide
